import React from 'react';
import { StyleSheet, Pressable } from 'react-native';
import { useModalStore } from '@/store';
import Text from '@/components/Typography/Text';
import ChatInputBanner from '@/components/ChatInput/ChatInputBanner';
import useTranslation from '@/hooks/useTranslation';

const styles = StyleSheet.create({
  link: {
     marginLeft: 4,
     display: 'inline',
     textDecorationLine: 'underline'
  },
});

function ChatInputGhostBanner({ level, isCloseable = false, isDetached = false }) {
  const { openModal } = useModalStore(state => state.actions);
  const { t } = useTranslation();

  return (
    <ChatInputBanner color="tertiary" level={level} isCloseable={isCloseable} isDetached={isDetached}>
      {t('chatInput.ghost.connectEmailMessage')}
      <Pressable onPress={() => openModal('GhostSignupModal')}>
        <Text size='s' weight='medium' color='primary' style={styles.link}>
          {t('chatInput.ghost.connectEmailLink')}
        </Text>
      </Pressable>
    </ChatInputBanner>
  );
} 

export default React.memo(ChatInputGhostBanner);